import styled from 'styled-components';
import React from 'react';
import { borderRadius } from 'polished';
import PostcodeAutocomplete from '../../js/components/autocomplete/postcode-autocomplete';
import { Input } from '../';
import PropTypes from 'prop-types';

const renderInput = inputProps => (
  <Input {...inputProps} type="text" name="search_zip" placeholder="Enter postcode" width={170} />
);

const Autocomplete = ({ onChange, value, onPostcodeSelected, className }) => (
  <div className={className}>
    <PostcodeAutocomplete
      focusInputOnSuggestionClick={false}
      onChange={onChange}
      classPrefix={className}
      value={value}
      onSuggestionSelected={onPostcodeSelected}
      renderInputComponent={renderInput}
    />
  </div>
);

Autocomplete.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  onPostcodeSelected: PropTypes.func,
  className: PropTypes.string
};

Autocomplete.defaultProps = {
  classPrefix: ''
};

const Styled = styled(Autocomplete)`
  & {
    display: inline-block;
    &__container {
      display: inline-block;
    }

    &__suggestions-container {
      display: none;
    }

    &__container--open &__suggestions-container {
      text-align: left;
      color: ${props => props.theme.back};
      position: absolute;
      width: 439px;
      border: 0;
      top: 42px;
      left: -1px;
      background-color: ${props => props.theme.snow};
      border: 1px solid #eee;
      border-top: 0;
      ${borderRadius('bottom', '5px')};
      z-index: 3;
    }

    &__container--open &__suggestions-container {
      display: block;
    }

    &__input {
      border-bottom-left-radius: 0 !important;
      border-top-left-radius: 0 !important;
    }

    &__container--open &__input {
      border-bottom-right-radius: 0 !important;
    }

    &__suggestions-list {
      margin: 0;
      padding: 0;
      list-style-type: none;

      li {
        font-size: 16px;
      }
    }

    &__suggestion {
      cursor: pointer;
      padding: 10px 20px;
      margin: 2px;
    }

    &__suggestion--focused {
      background-color: ${props => props.theme.primary};
      border-radius: 2px;
      color: ${props => props.theme.snow};
    }
  }
`;

export default Styled;
